import React from "react";
import { useWatch } from "react-hook-form";
import MyCheckboxLabel from "../../../../System/FormComponents/MyCheckboxLabel";
import ShowAndHide from "../../../../System/FormComponents/ShowAndHide";
import SepaDetail from "./SepaDetail";

const Sepa = ({ data, ...form }) => {
  const useSepa = useWatch({
    control: form?.control,
    name: "useSepa",
  });

  return (
    <ShowAndHide show={Boolean(data?.sepaPayment)}>
      <MyCheckboxLabel
        control={form.control}
        name="useSepa"
        label="I want to confirm using SEPA"
      />

      {data?.sepaPayment && (
        <div>
          <b className="text-main text-lg">
            Auto wire send: Will execute auto sepa payment
          </b>
        </div>
      )}

      <div className="flex flex-col">
        <div className="flex flex-1 w-full justify-between">
          {useSepa && (
            <div className="flex flex-col">
              <b className="text-orange-600 text-lg">Sepa BIB Payment</b>
            </div>
          )}
        </div>

        {useSepa && data?.sepaPayment && (
          <SepaDetail sepa={data?.sepaPayment} />
        )}
      </div>
    </ShowAndHide>
  );
};

export default Sepa;
